const circles = document.querySelectorAll( 'li.circle' );
const lineA = document.querySelectorAll( 'li.line-a' );
const lineB = document.querySelectorAll( 'div.line-b' );

circles.forEach((el) => {

  let a = new Waypoint({
    element: el,
    handler: function(direction) {
      el.classList.add('magic');
    },
    offset: '100%'
  });
});

lineA.forEach((el) => {

  let aa = new Waypoint({
    element: el,
    handler: function(direction) {
      el.classList.add('magic');
    },
    offset: 'bottom-in-view'
  });
});

lineB.forEach((el) => {

  let aaa = new Waypoint({
    element: el,
    handler: function(direction) {
      el.classList.add('magic');
    },
    offset: 'bottom-in-view'
  });
});
